
import Vue from 'vue';
import Modal from '@/components/Modal/index.vue';
import Button from '@/components/Button/index.vue';

export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loadingAccepted: {
      type: Boolean,
      default: false,
    },
    loadingNotAccepted: {
      type: Boolean,
      default: false,
    },
  },
  components: { Modal, Button },
});
